import React, { useState } from "react";

import toast from "react-hot-toast";
import axios from "axios";

import CustomDropdown from "../ReUseable/Dropdown/CustomDropdown";
import CustomDatePicker from "../ReUseable/CustomDatePicker/CustomDatePicker";
import CustomTimePicker from "../ReUseable/CustomTimePicker/CustomTimePicker";
import { API } from "../../global";

const EditTask = (props) => {
  const { showModal, setShowModal, logItem, fetchTasks } = props;

  const [frequency, setFrequency] = useState(logItem.occurrence);
  const [onceDate, setOnceDate] = useState(null);
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedDay, setSelectedDay] = useState(logItem.day);
  const [monthlyDayOption, setMonthlyDayOption] = useState(
    "Start date of each month"
  );

  const handleBackdropClick = () => {
    setShowModal(false);
  };

  const handleFrequencyChange = (option) => {
    setFrequency(option);
    if (option === "Once") {
      setOnceDate(new Date());
    } else {
      setStartDate(new Date());
      setEndDate(new Date());
    }
  };

  const handleDayChange = (option) => {
    if (frequency === "Weekly") {
      setSelectedDay(option);
    } else if (frequency === "Monthly") {
      setMonthlyDayOption(option);
    }
  };

  const handleUpdate = async () => {
    let scheduleDetails = {
      taskId: logItem._id,
      occurrence: frequency,
      date: "",
      startDate: "",
      endDate: "",
      time: "",
      day: "",
    };

    if (frequency === "Once") {
      scheduleDetails.date = onceDate ? onceDate : new Date(logItem.date);
      scheduleDetails.time = selectedTime ? selectedTime : logItem.time;
    } else if (frequency === "Daily") {
      scheduleDetails.startDate = startDate ? startDate : new Date(logItem.startDate);
      scheduleDetails.endDate = endDate ? endDate : new Date(logItem.endDate);
      scheduleDetails.time = selectedTime ? selectedTime : logItem.time;
    } else if (frequency === "Hourly") {
      scheduleDetails.startDate = startDate ? startDate : new Date(logItem.startDate);
      scheduleDetails.endDate = endDate ? endDate : new Date(logItem.endDate);
    } else if (frequency === "Weekly") {
      scheduleDetails.startDate = startDate ? startDate : new Date(logItem.startDate);
      scheduleDetails.endDate = endDate ? endDate : new Date(logItem.endDate);
      scheduleDetails.day = selectedDay;
      scheduleDetails.time = selectedTime ? selectedTime : logItem.time;
    } else if (frequency === "Monthly") {
      scheduleDetails.startDate = startDate ? startDate : new Date(logItem.startDate);
      scheduleDetails.endDate = endDate ? endDate : new Date(logItem.endDate);
      scheduleDetails.day = monthlyDayOption;
      scheduleDetails.time = selectedTime ? selectedTime : logItem.time;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("auth_token")}`
      }
    };
    const res = await axios.post(`${API}/schedule-task/update`, JSON.stringify(scheduleDetails), config);
    if (res.data.success) {
      toast.success("Task updated successfully");
      setShowModal(false);
      fetchTasks();
    } else {
      toast.error(res.data.error.msg);
      setShowModal(false);
    }
  }

  const handleDateChange = (date) => {
    setOnceDate(date);
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
  }

  const handleEndDateChange = (date) => {
    setEndDate(date);
  }

  const handleTimeChange = (newHours, newMinutes, newAmPm) => {
    setSelectedTime(`${newHours}:${newMinutes} ${newAmPm}`);
  }

  return (
    <>
      {showModal && (
        <div
          data-dialog-backdrop="dialog-md"
          data-dialog-backdrop-close="true"
          className="fixed inset-0 z-[999] grid h-screen w-screen place-items-center bg-black bg-opacity-50 backdrop-blur-sm transition-opacity duration-300"
          onClick={handleBackdropClick}
        >
          <div
            data-dialog="dialog-md"
            className="relative m-4 p-8 w-2/5 rounded-lg bg-white shadow-sm"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-xl font-semibold mb-2">Edit Task</h2>
            <hr className="w-full border-t-1 border-[#0083BF] mb-6" />
            <div className="flex justify-between w-full mb-4 items-center">
              <label
                htmlFor="frequency"
                className="block text-sm font-medium text-[#333333]"
              >
                Repeat
              </label>
              <div className="w-[70%]">
                <CustomDropdown
                  options={["Once", "Hourly", "Daily", "Weekly", "Monthly"]}
                  placeholder="Select frequency"
                  onSelect={handleFrequencyChange}
                  width="70%"
                  selected={frequency}
                />
              </div>
            </div>

            {frequency === "Once" && (
              <div className="flex justify-between w-full mb-4 items-center">
                <label
                  htmlFor="once-date"
                  className="block text-sm font-medium text-[#333333]"
                >
                  Date
                </label>
                <div className="w-[70%]">
                  <CustomDatePicker
                    selected={logItem.date ? new Date(logItem.date) : new Date()}
                    onSelect={handleDateChange}
                  />
                </div>
              </div>
            )}

            {frequency !== "Once" && (
              <>
                <div className="flex justify-between w-full mb-4 items-center">
                  <label
                    htmlFor="start-date"
                    className="block text-sm font-medium text-[#333333]"
                  >
                    Start Date
                  </label>
                  <div className="w-[70%]">
                    <CustomDatePicker
                      selected={logItem.startDate ? new Date(logItem.startDate) : new Date()}
                      onSelect={handleStartDateChange}
                      maxDate={endDate}
                    />
                  </div>
                </div>

                <div className="flex justify-between w-full mb-4 items-center">
                  <label
                    htmlFor="end-date"
                    className="block text-sm font-medium text-[#333333]"
                  >
                    End Date
                  </label>
                  <div className="w-[70%]">
                    <CustomDatePicker
                      selected={logItem.endDate ? new Date(logItem.endDate) : new Date()}
                      onSelect={handleEndDateChange}
                      minDate={startDate}
                    />
                  </div>
                </div>
              </>
            )}

            {frequency === "Weekly" && (
              <div className="flex justify-between w-full mb-4 items-center">
                <label
                  htmlFor="day"
                  className="block text-sm font-medium text-[#333333]"
                >
                  Day
                </label>
                <div className="w-[70%]">
                  <CustomDropdown
                    options={[
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ]}
                    placeholder="Select day"
                    onSelect={handleDayChange}
                    width="70%"
                    selected={selectedDay}
                  />
                </div>
              </div>
            )}

            {frequency === "Monthly" && (
              <div className="flex justify-between w-full mb-4 items-center">
                <label
                  htmlFor="monthly-option"
                  className="block text-sm font-medium text-[#333333]"
                >
                  Day
                </label>
                <div className="w-[70%]">
                  <CustomDropdown
                    options={[
                      "Start date of each month",
                      "End date of each month",
                    ]}
                    placeholder="Select option"
                    onSelect={handleDayChange}
                    width="70%"
                    selected={monthlyDayOption}
                  />
                </div>
              </div>
            )}

            {frequency !== "Hourly" && (
              <div className="flex justify-between w-full mb-4 items-center">
                <label
                  htmlFor="time"
                  className="block text-sm font-medium text-[#333333]"
                >
                  Time
                </label>
                <div className="w-[70%]">
                  <CustomTimePicker
                    onSelect={handleTimeChange}
                    selected={logItem.time}
                  />
                </div>
              </div>
            )}

            <div className="flex justify-end w-full gap-4">
              <button
                className="py-1 px-4 bg-gray-200 text-gray-700 rounded-md"
                onClick={handleBackdropClick}
              >
                Cancel
              </button>
              <button
                className="py-1 px-4 bg-[#0083BF] text-white rounded-md"
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditTask;